// extracted by mini-css-extract-plugin
export default {"section":"F05vucy3dha1xkXGhIjj","inputFieldFontFamily":"Lswa_e7FIEHOFpDvaByP"};